<div class="table-container margin-left-28">
    <table class="full-width">
        <tr class="table-row-container">
            <ng-container [formGroup]="laborCostRowForm">
                <td class="estimate-table-column width-190">{{ rowLabel | translate}}</td>
                <td class="estimate-table-column width-110">
                    {{ laborCostRowForm.controls.cost.value | multilingualCurrency }}
                </td>
                <td class="estimate-table-column width-70">
                    {{ laborCostRowForm.controls.escalate.value }}
                    @if(laborCostRowForm.controls.escalate.value) {
                    <span (click)="openEscalationDialog(rowLabel)" class="custom-anchor">
                        <img class="escalation-icon" src="assets/images/Escalation.JPG" alt="Escalation Image Icon">
                    </span>
                }
                </td>
                <td class="estimate-table-column width-70">
                    {{ laborCostRowForm.controls.tdcPercentage.value | decimalPrecision }}%
                </td>
                <td class="estimate-table-column width-70">
                    <ng-container *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else notLabor">
                        <ng-container *ngIf="isMarkUpSelected; else notMarkUp">
                            <mat-form-field appearance="outline" class="mat-input-alignment width-70 margin-field" [class.margin-field-changed]="!estimateTab?.[sellPriceFlag]">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal" formControlName="markUpPercentage" class="input-alignment" />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #notMarkUp>
                            <mat-form-field appearance="outline" class="mat-input-alignment width-70 margin-field" [class.margin-field-changed]="!estimateTab?.[sellPriceFlag]">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig" inputmode="decimal" formControlName="grossMarginPercentage" class="input-alignment" />
                            </mat-form-field>
                        </ng-template>
                    </ng-container>
                    <ng-template #notLabor>
                        <ng-container *ngIf="isMarkUpSelected; else notMarkUp">
                            {{ laborCostRowForm.controls.markUpPercentage.value | decimalPrecision }}%
                        </ng-container>
                        <ng-template #notMarkUp>
                            {{ laborCostRowForm.controls.grossMarginPercentage.value | decimalPrecision }}%
                        </ng-template>
                    </ng-template>
                </td>
                <td class="estimate-table-column width-210 padding-gm">
                    {{ laborCostRowForm.controls.grossMargin.value | multilingualCurrency }}
                </td>
                <td class="estimate-table-column width-110">
                    <ng-container *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else noInputSellPrice">
                        <mat-form-field appearance="outline" class="mat-input-alignment width-110" [class.sell-price-changed]="estimateTab?.[sellPriceFlag]">
                            <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.sellPriceConfig" [showStepper]="false" inputmode="decimal" formControlName="sellPrice" class="input-alignment" />
                        </mat-form-field>
                    </ng-container>
                    <ng-template #noInputSellPrice>
                        {{ laborCostRowForm.controls.sellPrice.value | multilingualCurrency }}
                    </ng-template>
                </td>
            </ng-container>
        </tr>
    </table>
</div>